import { Component } from '@angular/core';

@Component({
  selector: 'app-clipboard-icon',
  templateUrl: './clipboard-icon.component.html',
  styleUrl: './clipboard-icon.component.scss',
})
export class ClipboardIconComponent {}
